module.exports = __webpack_public_path__ + "img/floor_4_bg.9e31a694.png";